module.exports = __webpack_public_path__ + "img/tel.03aa6e71.png";